import React, { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import { useDispatch, useSelector } from "react-redux";
import { addRatingForProduct, getProductRating } from "../../Redux/RatingRedux";
import Button from "@mui/material/Button";
import FastForwardIcon from "@mui/icons-material/FastForward";
import FastRewindIcon from "@mui/icons-material/FastRewind";
import toast from "react-hot-toast";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import StarsIcon from "@mui/icons-material/Stars";

function Reviews({ productDetails, setFlag }) {
  const dispatch = useDispatch();
  const { productRatings } = useSelector((state) => state.ratingRedux);

  const authenticated = sessionStorage.getItem("authenticated");
  const user = JSON.parse(localStorage.getItem("user"));
  const [selected, setSelected] = useState("");
  const [review, setReview] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [page, setPage] = useState(0);

  let rowsPerPage = 5;
  const paginatedData = productRatings?.data?.ratings
    ? productRatings.data.ratings.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      )
    : [];

  const rating = [
    { rate: 1 },
    { rate: 2 },
    { rate: 3 },
    { rate: 4 },
    { rate: 5 },
  ];

  useEffect(() => {
    dispatch(getProductRating(productDetails._id));
  }, [dispatch, productDetails]);

  const handleRating = (data) => {
    setSelected(data.rate);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const clear = () => {
    setEmail("");
    setName("");
    setReview("");
    setSelected("");
  };

  const formatDateToIST = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-IN", {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selected) {
      toast.error("Please select your rating");
      // alert('Select Rating');
    } else if (authenticated) {
      const data = {
        name: user.userName,
        email: user.emailId,
        rate: selected,
        review: review,
      };
      dispatch(addRatingForProduct(productDetails._id, data))
        .then((result) => {
          if (result.status === "success") {
            dispatch(getProductRating(productDetails._id));
            clear();
            setFlag(true);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      const data = { name: name, email: email, rate: selected, review: review };
      dispatch(addRatingForProduct(productDetails._id, data))
        .then((result) => {
          if (result.status === "success") {
            dispatch(getProductRating(productDetails._id));
            clear();
            setFlag(true);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  return (
    <div className="row p-3">
      {productRatings?.data?.ratings && (
        <label className="mb-3">
          {productRatings.data.ratings.length} Reviews for{" "}
          <strong>{productDetails.productName}</strong>
        </label>
      )}
      <div className="col-12 col-md-6 order-1 order-md-2">
        {paginatedData.length > 0 ? (
          paginatedData.map((rating) => (
            <>
              <div className="row">
                <div className="col-1">
                  <Avatar
                    alt={rating.name}
                    src={rating.imageUrl || ""}
                    sx={{ width: 70, height: 70 }}
                  >
                    {!rating.imageUrl && rating.name
                      ? rating.name.charAt(0).toUpperCase()
                      : null}
                  </Avatar>
                </div>
                <div className="col-5">
                  <div className="row">
                    <p>
                      Rated <strong>{rating.rate}</strong> out of 5
                    </p>
                    <span>
                      <strong>{rating.name}</strong> -{" "}
                      {formatDateToIST(rating.createdAt)}
                    </span>
                    <p>{rating.review}</p>
                  </div>
                  <hr />
                </div>
              </div>
              <div className="d-flex justify-content-center col-12 mb-3">
                <Button
                  className="btn mt-3 ms-4"
                  color="success"
                  type="submit"
                  disabled={page === 0}
                  onClick={() => handleChangePage(null, page - 1)}
                  variant="text"
                  startIcon={<FastRewindIcon />}
                >
                  previous
                </Button>
                <Button
                  className="btn mt-3 ms-4"
                  type="submit"
                  color="success"
                  onClick={() => handleChangePage(null, page + 1)}
                  disabled={
                    page >=
                    Math.ceil(
                      (productRatings?.data?.ratings?.length || 0) / rowsPerPage
                    ) -
                      1
                  }
                  endIcon={<FastForwardIcon />}
                >
                  next
                </Button>
              </div>
            </>
          ))
        ) : (
          <div
            className="col-12 d-flex align-items-center justify-content-center"
            style={{ minHeight: "100%" }}
          >
            <div
              className="d-flex align-items-center gap-2"
              style={{
                backgroundColor: "#FFF8E1", 
                border: "1px solid #FFD54F", 
                color: "#8D6E00", 
                borderRadius: "8px",
                padding: "12px 18px",
                fontSize: "15px",
                fontWeight: 500,
                boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
              }}
            >
              <ThumbUpIcon
                style={{
                  fontSize: "25px",
                  color: "#F9A825", 
                }}
              />
              <span>Be the first to review this product</span>
            </div>
          </div>
        )}
      </div>
      <div className="col-12 col-md-6 order-2 order-md-1">
        <form onSubmit={handleSubmit}>
          <div className="row mt-4">
            <h6>Add a review</h6>
            <label className="mt-2">
              Your email address will not be published. Required fields are
              marked
              <span className="requiredAsterisk">*</span>
            </label>
            <div className="col-12 col-md-5 mt-3">
              <label className="me-2 me-md-4">
                Your rating <span className="requiredAsterisk">*</span>
              </label>
              {rating.map((data) => (
                <button
                  key={data.rate}
                  type="button"
                  onClick={() => handleRating(data)}
                  value={selected}
                  className="p-2 ms-1 text-white border-0 d-inline-flex align-items-center justify-content-center"
                  style={{
                    borderRadius: "50%",
                    width: "30px",
                    height: "30px",
                    cursor: "pointer",
                    background: selected === data.rate ? "#c4a41f" : "#9aa2a3",
                  }}
                >
                  {data.rate}
                </button>
              ))}
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-12 col-md-6">
              <label htmlFor="reviewText" className="mt-2">
                Your review <span className="requiredAsterisk">*</span>
              </label>
              <textarea
                id="reviewText"
                value={review}
                className="form-control mt-2"
                style={{ border: "1px solid #cccccc", height: "120px" }}
                rows="6"
                onChange={(e) => setReview(e.target.value)}
                required
              />
              {!authenticated && (
                <>
                  <label htmlFor="registerName" className="mt-2">
                    Name <span className="requiredAsterisk">*</span>
                  </label>
                  <input
                    type="text"
                    id="registerName"
                    name="registerName"
                    value={name}
                    className="form-control mt-2"
                    style={{ border: "1px solid #cccccc" }}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                  <label htmlFor="registerEmail" className="mt-2">
                    Email <span className="requiredAsterisk">*</span>
                  </label>
                  <input
                    type="email"
                    id="registerEmail"
                    name="registerEmail"
                    value={email}
                    className="form-control mt-2"
                    style={{ border: "1px solid #cccccc" }}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </>
              )}
              <button
                className="btn mt-3"
                style={{ background: "#2b6930", color: "#fff" }}
                type="submit"
              >
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Reviews;
